import { render } from "./footerCom.vue?vue&type=template&id=358cec2f&scoped=true"
import script from "./footerCom.vue?vue&type=script&lang=js"
export * from "./footerCom.vue?vue&type=script&lang=js"

import "./footerCom.vue?vue&type=style&index=0&id=358cec2f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-358cec2f"]])

export default __exports__